import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',

    '& .avatar': {
      marginRight: '0.5rem',
      width: '2rem !important',
      height: '2rem !important',
      fontSize: theme.size.sm
    }
  }
}))

export default useStyles
